import React, { useEffect, useContext } from "react";
import { Button, Checkbox, Form, Input } from "antd";
import Icon from '@ant-design/icons';
import { Link, useHistory } from "react-router-dom";

import { message } from "antd/lib/index";
import CircularProgress from "components/CircularProgress/index";
import GoogleOutlined from "@ant-design/icons/lib/icons/GoogleOutlined";
import FacebookOutlined from "@ant-design/icons/lib/icons/FacebookOutlined";
import GithubOutlined from "@ant-design/icons/lib/icons/GithubOutlined";
import TwitterOutlined from "@ant-design/icons/lib/icons/TwitterOutlined";
import { context } from '../context'

const FormItem = Form.Item;

const SignUp = (props) => {

  const { state, actions } = useContext(context)
  const { loader, alertMessage, showMessage, authUser } = state

  const history = useHistory();

  useEffect(() => {
    if (showMessage) {
      setTimeout(() => {
        actions.hideMessage()
      }, 100);
    }
    if (authUser !== null) {
      history.push('/');
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    props.form.validateFields((err, values) => {
      console.log("values", values);
      if (!err) {
        actions.showAuthLoader()
        actions.userSignUp(values)
      }
    });
  };

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };

  const onFinish = values => {
    actions.showAuthLoader()
    actions.userSignUp(values)
  };

  return (
    <div className="gx-app-login-wrap">
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content">
          <div className="gx-app-logo-content">
            <div className="gx-app-logo-content-bg">
              <img src={"https://via.placeholder.com/272x395"} alt='Neature' />
            </div>
            <div className="gx-app-logo-wid">
              <h1>Sign Up</h1>
              <p>By Signing Up, you can avail full features of our services.</p>
              <p>Get an account !!!</p>
            </div>
            <div className="gx-app-logo">
              <img alt="example" src={require("assets/images/logo.png")} />
            </div>
          </div>

          <div className="gx-app-login-content">
            <Form
              initialValues={{ remember: true }}
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className="gx-signin-form gx-form-row0">
              <FormItem rules={[{ required: true, message: 'Please input your username!' }]} name="Username">
                <Input placeholder="Username" />
              </FormItem>

              <FormItem name="email" rules={[{
                required: true, type: 'email', message: 'The input is not valid E-mail!',
              }]}>
                <Input placeholder="Email" />
              </FormItem>
              <FormItem name="password"
                rules={[{ required: true, message: 'Please input your Password!' }]}>
                <Input type="password" placeholder="Password" />
              </FormItem>
              <FormItem name="remember" valuePropName="checked">
                <Checkbox>Remember me</Checkbox>
                <Link className="gx-login-form-forgot" to="/custom-views/user-auth/forgot-password">Forgot password</Link>
              </FormItem>
              <FormItem>
                <Button type="primary" className="gx-mb-0" htmlType="submit">
                  Sign Up
                </Button>
                <span>or</span> <Link to="/signin">Sign In</Link>
              </FormItem>
              <div className="gx-flex-row gx-justify-content-between">
                <span>or connect with</span>
                <ul className="gx-social-link">
                  <li>
                    <GoogleOutlined
                    // onClick={() => console.log()}
                    />
                  </li>
                  <li>
                    <FacebookOutlined
                    // onClick={() => console.log()}
                    />
                  </li>
                  <li>
                    <GithubOutlined
                    // onClick={() => console.log()}
                    />
                  </li>
                  <li>
                    <TwitterOutlined
                    // onClick={() => console.log()}
                    />
                  </li>
                </ul>
              </div>
            </Form>
          </div>
          {loader &&
            <div className="gx-loader-view">
              <CircularProgress />
            </div>
          }
          {showMessage &&
            message.error(alertMessage)}
        </div>
      </div>
    </div>
  );
};


export default SignUp;
